import Footer from "components/Footers";
import GuestGuard from "components/Guards/GuestGuard";
import PublicNavbar from "components/Navbars/PublicNavbar";
import routes from "routes";
import { renderRoutes } from "routes";

const PublicLayout = (props) =>{
    return (
        <GuestGuard>
          <>
            <PublicNavbar />
            <div
              className="page-header"
              style={{ backgroundImage: "url(" + require("assets/img/login-image.jpg").default + ")", }} 
            >
              <div className="filter" />
                {renderRoutes(routes)}
                <Footer fluid />
            </div>
          </>
        </GuestGuard>
      );
};

export default PublicLayout;